import type { ReactNode } from 'react';

interface ToggleProps {
  pressed: boolean;
  onToggle: (next: boolean) => void;
  label: ReactNode;
  /** Accessible name when the visible label is not a string. */
  ariaLabel?: string;
  count?: ReactNode;
  disabled?: boolean;
  className?: string;
}

/** Toggle row with real button semantics (`aria-pressed`), knob painted with tokens. */
export function Toggle({
  pressed,
  onToggle,
  label,
  ariaLabel,
  count,
  disabled = false,
  className,
}: ToggleProps) {
  return (
    <button
      type="button"
      className={['lrow', className].filter(Boolean).join(' ')}
      aria-pressed={pressed}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onToggle(!pressed)}
    >
      <span className="knob" />
      {label}
      {count === undefined ? null : <span className="cnt">{count}</span>}
    </button>
  );
}
